import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { useEffect, useState } from 'react';
import WQSystemSelect from './components/WQSystemSelect';
import TextField from '@mui/material/TextField';
import { Checkbox } from '@upmc/ims.component-library';
import styles from '../../ApplicationMaintenance.module.scss';
import { WORK_QUE_TYPES } from '../../_constants';
const WorkQueTypeSelect = ({
	workQueType,
	setWorkQueType,
	systemID = null,
	setSystemID,
	systemName,
	setSystemName,
}) => {
	const [useCustomName, setUseCustomName] = useState(false);

	const DEFAULT = WORK_QUE_TYPES.DESIGNATED_WQ;

	useEffect(() => {
		//on initial render, set WorkQueType to default value
		setWorkQueType(WORK_QUE_TYPES.DESIGNATED_WQ);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	//when the use custom wq name checkbox is unchecked, reset the systemName value to null
	useEffect(() => {
		if (useCustomName === false) {
			setSystemName(systemName);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [useCustomName, setSystemName]);

	return (
		<FormControl>
			<FormLabel id='WQTypes-radio-group-label'>
				Select Work Queue Type
			</FormLabel>
			<RadioGroup
				defaultValue={workQueType ?? DEFAULT}
				name='WQ-radio-buttons-group'
				onChange={e => setWorkQueType(e.target.value)}
			>
				<FormControlLabel
					value={WORK_QUE_TYPES.DESIGNATED_WQ}
					control={<Radio />}
					label='Designated Work Queue'
					id='WQ_DesignatedWQ_radio'
				/>
				{workQueType === WORK_QUE_TYPES.DESIGNATED_WQ ? (
					<div className={styles.padding_left_medium}>
						<Checkbox
							id='WQ_Custom_Name_Checkbox'
							label='Custom Name'
							checked={useCustomName}
							onChange={e => setUseCustomName(e.target.checked)}
						/>
						<br />
						{useCustomName ? (
							<TextField
								id='WQ_Name_Input'
								label={`System Name (${
									systemName?.length ?? '0'
								}/64)`}
								inputProps={{ maxLength: 64 }}
								onChange={e => setSystemName(e.target.value)}
								value={systemName}
							/>
						) : null}
					</div>
				) : null}
				<FormControlLabel
					value={WORK_QUE_TYPES.ADD_TO_EXISTING_WQ}
					control={<Radio />}
					label='Add To Existing Work Queue'
					id='WQ_AddToExisting_radio'
				/>
				{workQueType === WORK_QUE_TYPES.ADD_TO_EXISTING_WQ ? (
					<WQSystemSelect
						systemID={systemID}
						setSystemID={setSystemID}
					/>
				) : null}
					<FormControlLabel
						value={WORK_QUE_TYPES.AUTO_COMPLETE}
						control={<Radio />}
						label='Auto-Complete'
						id='WQ_AutoComplete_radio'
					/>
			</RadioGroup>
		</FormControl>
	);
};

export default WorkQueTypeSelect;
